import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useMsal } from "@azure/msal-react";
import { IconTrash } from "@tabler/icons-react";
import { deleteOrnament, fetchOrnaments } from "../api/ornaments";
import { bowColorHex } from "../types/api";
import DateGroupedGallery from "../components/gallery/DateGroupedGallery";
import GalleryCard from "../components/gallery/GalleryCard";
import { GENERATOR_VIEWS, Page, ViewSwitch } from "../components/ui";

export default function GalleryOrnamentsPage() {
  const { instance } = useMsal();
  const navigate = useNavigate();
  const [total, setTotal] = useState(0);

  return (
    <Page
      title="Gallery"
      description={total > 0 ? `Ornaments · ${total}` : "Ornaments"}
      actions={<ViewSwitch base="/gallery" options={GENERATOR_VIEWS} />}
    >
      <DateGroupedGallery
        fetchPage={fetchOrnaments}
        emptyMessage="No ornaments yet"
        onTotal={setTotal}
        renderItem={(item, { remove }) => (
          <GalleryCard
            key={item.id}
            src={item.photoUrl ?? item.imageUrl}
            alt={item.id}
            tint={item.bowColor === null ? null : bowColorHex(item.bowColor)}
            onOpen={() => navigate(`/gallery/ornaments/${item.id}`)}
            actions={[
              {
                label: "Delete",
                icon: <IconTrash size={14} />,
                color: "red",
                onClick: () => void deleteOrnament(instance, item.id).then(() => remove(item.id)),
              },
            ]}
          />
        )}
      />
    </Page>
  );
}
